import { Attribute as CoreAttribute } from '@df/catalog/attribute/attribute';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { Catalog } from '@df/catalog/catalog.interfaces';
import sortBy from 'lodash-es/sortBy';

export class Attribute extends CoreAttribute {
    override setData(resultData: Catalog.IAttributeData): void {
        if (resultData.options?.length) {
            resultData.options = sortBy(resultData.options, o => {
                const label = o.label?.toString().toLowerCase();

                // Try to extract numeric value from the label, if it exists
                const numericValue = parseFloat(label);

                // If the label contains a valid number, return the numeric value for sorting
                // Otherwise, return the string itself to sort alphabetically
                // need for proper sort 100mm, 10mm, 1mm
                return isNaN(numericValue) ? label : numericValue;
            });
        }
        super.setData(resultData);
    }
}

AttributeResource.instance = Attribute;
